import httpClient from 'shared/utils/http-client'

export const XENDIT_ACCOUNT_API = '/api/payment/integration/xendit/account'

export const xenditDisconnect = () => httpClient.delete(`${XENDIT_ACCOUNT_API}/disconnect`)
